import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

export interface IRegData {
  step_name: string;
  step_data: any;
}

const initialState: IRegData = {
  step_name: '',
  step_data: null,
};

export const regSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    updateStepName: (state, action: PayloadAction<string>) => {
      state.step_name = action.payload;
    },
    updateStepData: (state, action: PayloadAction<any>) => {
      state.step_data = action.payload;
    },
  },
});

export const { updateStepName, updateStepData } = regSlice.actions;

export const selectReg = (state: RootState) => state.registration;

export default regSlice.reducer;
